
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

interface FormFieldsProps {
  title: string;
  content: string;
  tags: string;
  notes: string; // Added notes field
  selectedFile: File | null;
  onTitleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onContentChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onTagsChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onNotesChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void; // Added notes handler
  hideContent?: boolean;
  hideTitle?: boolean;
  hideMetadata?: boolean;
}

export function FormFields({
  title,
  content,
  tags,
  notes, // Added notes prop
  selectedFile,
  onTitleChange,
  onContentChange,
  onTagsChange,
  onNotesChange, // Added notes handler
  hideContent = false,
  hideTitle = false,
  hideMetadata = false,
}: FormFieldsProps) {
  return (
    <>
      {!hideTitle && (
        <div className="mb-4">
          <Label htmlFor="title">Title</Label>
          <Input
            id="title"
            placeholder="Title"
            value={title}
            onChange={onTitleChange}
            required
          />
        </div>
      )}
      
      {!hideMetadata && (
        <>
          <div className="mb-4">
            <Label htmlFor="tags">Tags (comma-separated)</Label>
            <Input
              id="tags"
              placeholder="Tags (comma-separated)"
              value={tags}
              onChange={onTagsChange}
            />
          </div>
          
          <div className="mb-4">
            <Label htmlFor="notes">Additional Notes</Label>
            <Textarea
              id="notes"
              placeholder="Additional notes about this document (e.g., 'Applies to all VW models from 2010 to present')"
              value={notes}
              onChange={onNotesChange}
              className="min-h-[100px]"
            />
          </div>
        </>
      )}
      
      {!hideContent && !selectedFile && (
        <div>
          <Label htmlFor="content">Content</Label>
          <Textarea
            id="content"
            placeholder="Content"
            value={content}
            onChange={onContentChange}
            required
            className="min-h-[200px]"
          />
        </div>
      )}
    </>
  );
}
